import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger/src/";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";

import { SYNC_STATE as SYNC_AUTH_STATE } from "common/reducers/authentication";
import { SYNC_STATE as SYNC_SETTINGS_STATE } from "common/reducers/settings";
// import { SYNC_STATE as SYNC_MAPPINGS_STATE } from "common/reducers/mappings";
import { listenForLocalStorageChanges } from "common/helpers/localStorageReducer";

import { reducers } from "./reducers";

export const getMiddleware = () => {
    if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "test") {
        return applyMiddleware(thunk);
    }
    
    // Enable additional logging in non-production environments.
    return applyMiddleware(thunk, createLogger());
};

export const store = createStore(reducers, composeWithDevTools(getMiddleware()));

// Sync reducers state between tabs
// MRREF: add sync for mappings

listenForLocalStorageChanges({
    key: "authentication",
    reducerKey: "authentication",
    store,
    syncAction: SYNC_AUTH_STATE
});

listenForLocalStorageChanges({
    key: "settings_dev",
    reducerKey: "settings",
    store,
    syncAction: SYNC_SETTINGS_STATE
});

/**
 * Initializes the sidebar CSS class toggle if the feature flag is
 *   enabled.
 * @todo Remove this function when the new sidebar is fully adopted.
 */
function initializeSidebarClassToggle() {
    let previousSidebarMode = null;
    
    const updateSidebarClass = () => {
        const { sidebar2pt0 } = store.getState().settings;
        const sidebarMode = sidebar2pt0 ? "2pt0" : "legacy";
        
        // Only update if the mode actually changed to avoid unnecessary DOM operations
        if (sidebarMode !== previousSidebarMode) {
            document.body.classList.toggle("sidebar2pt0", sidebar2pt0);
            previousSidebarMode = sidebarMode;
        }
    };

    updateSidebarClass();
    store.subscribe(updateSidebarClass);
}

initializeSidebarClassToggle();
